// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__OX7Ml","dropdown_admin":"style_dropdown_admin__ZPc9z","avatar":"style_avatar__8j8kN","menuIcon":"style_menuIcon__qiVSu"};